import CurrencyMask from '_common/mixins/CurrencyMask';
import NumberExtenso from 'numero-por-extenso';
import { firstLetterUppercase } from '_utils/string';

export default {
  mixins: [CurrencyMask],
  methods: {
    setCustomerMessage(message, customer) {
      message = message.replace('{{cliente.nome}}', customer.name);
      message = message.replace('{{cliente.contato}}', customer.contact_name);
      message = message.replace('{{cliente.tipo_documento}}', (customer.type === 'individual') ? 'CPF' : 'CNPJ');
      message = message.replace('{{cliente.documento}}', customer.document);
      return message;
    },
    setQuotationMessage(message, quotation) {
      const total = this.addCurrencyMask(quotation.total);
      message = message.replace('{{orcamento.total}}', `${total}`);
      message = message.replace('{{orcamento.total_extenso}}', this.setNumberMessage(quotation.total));
      message = message.replace('{{orcamento.id}}', quotation.reference_no);
      return message;
    },
    setNumberMessage(number) {
      const total = NumberExtenso.porExtenso(number, NumberExtenso.estilo.monetario);
      return firstLetterUppercase(total);
    },
  },
};
